'use es6';

import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import I18n from 'I18n';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import partial from 'react-utils/partial';
import classNames from 'classnames';
import SyntheticEvent from '../core/SyntheticEvent';
import UITooltip from '../tooltip/UITooltip';
import UIButton from '../button/UIButton';
import UIIcon from '../icon/UIIcon';
import Controllable from '../decorators/Controllable';

var getMinAndMaxPageNumbers = function getMinAndMaxPageNumbers(maxVisiblePageButtons, page, pageCount) {
  var buffer = (maxVisiblePageButtons - 1) / 2;
  var min = page - buffer;
  var max = page + buffer;
  var numPagesToShow = Math.min(maxVisiblePageButtons, pageCount);

  if (min < 1) {
    min = 1;
    max = min + maxVisiblePageButtons - 1;
  }

  if (max > pageCount) {
    max = Math.max(pageCount, 1);
    min = max - numPagesToShow + 1;
  }

  return [Math.floor(min), Math.floor(max)];
};

var UIPaginator = /*#__PURE__*/function (_PureComponent) {
  _inherits(UIPaginator, _PureComponent);

  function UIPaginator() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, UIPaginator);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(UIPaginator)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.goToPage = function (page) {
      if (page === _this.props.page) return;

      _this.props.onPageChange(SyntheticEvent(page));
    };

    return _this;
  }

  _createClass(UIPaginator, [{
    key: "renderNumberedPages",
    value: function renderNumberedPages(maxVisiblePageButtons, page, pageCount, enabledPageLimit, disabledPageTooltipTitle) {
      var _getMinAndMaxPageNumb = getMinAndMaxPageNumbers(maxVisiblePageButtons, page, pageCount),
          _getMinAndMaxPageNumb2 = _slicedToArray(_getMinAndMaxPageNumb, 2),
          min = _getMinAndMaxPageNumb2[0],
          max = _getMinAndMaxPageNumb2[1];

      var links = [];

      for (var currentPage = min; currentPage <= max; currentPage++) {
        var isActive = currentPage === page;
        links.push(React.createElement(UITooltip, {
          disabled: enabledPageLimit == null || enabledPageLimit != null && currentPage <= enabledPageLimit,
          title: disabledPageTooltipTitle,
          key: currentPage - min
        }, React.createElement(UIButton, {
          active: isActive,
          "aria-current": isActive ? 'true' : null,
          className: "private-paginator__button private-paginator__button--numeric" + (isActive ? " private-paginator__button--active" : ""),
          "data-page-number": currentPage,
          disabled: enabledPageLimit != null && currentPage > enabledPageLimit,
          key: currentPage - min,
          onClick: partial(this.goToPage, currentPage),
          responsive: false,
          size: "xs",
          use: "transparent"
        }, React.createElement("span", {
          className: "sr-only"
        }, isActive ? I18n.text('salesUI.UIPaginator.pageNumber.currentIndicator') : null, I18n.text('salesUI.UIPaginator.pageNumber.description')), currentPage)));
      }

      return links;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          disabledPageTooltipTitle = _this$props.disabledPageTooltipTitle,
          enabledPageLimit = _this$props.enabledPageLimit,
          maxVisiblePageButtons = _this$props.maxVisiblePageButtons,
          __onPageChange = _this$props.onPageChange,
          page = _this$props.page,
          pageCount = _this$props.pageCount,
          showFirstLastButtons = _this$props.showFirstLastButtons,
          showButtonLabels = _this$props.showButtonLabels,
          rest = _objectWithoutProperties(_this$props, ["className", "disabledPageTooltipTitle", "enabledPageLimit", "maxVisiblePageButtons", "onPageChange", "page", "pageCount", "showFirstLastButtons", "showButtonLabels"]);

      var arrowButtonClassName = showButtonLabels ? '' : 'sr-only';
      return React.createElement("nav", Object.assign({
        "aria-label": I18n.text('salesUI.UIPaginator.label'),
        className: classNames('private-paginator', className),
        "data-current-page": page,
        role: "navigation"
      }, rest), React.createElement("span", {
        className: "private-paginator__backward-controls"
      }, showFirstLastButtons ? React.createElement(UIButton, {
        "aria-label": I18n.text('salesUI.UIPaginator.firstPage.description'),
        className: "private-paginator__button",
        "data-first-page": true,
        disabled: page < 2,
        key: "first",
        onClick: partial(this.goToPage, 1),
        responsive: false,
        size: "xs",
        use: "transparent"
      }, React.createElement(UIIcon, {
        className: "private-paginator__icon",
        name: "first"
      }), React.createElement("span", {
        className: arrowButtonClassName
      }, I18n.text('salesUI.UIPaginator.firstPage.label'))) : null, React.createElement(UIButton, {
        "aria-label": I18n.text('salesUI.UIPaginator.previousPage.description'),
        className: "private-paginator__button",
        "data-prev-page": true,
        disabled: page < 2,
        key: "prev",
        onClick: partial(this.goToPage, Math.max(page - 1, 1)),
        responsive: false,
        size: "xs",
        use: "transparent"
      }, React.createElement(UIIcon, {
        className: "private-paginator__icon",
        name: "left",
        size: "xs"
      }), React.createElement("span", {
        className: arrowButtonClassName
      }, I18n.text('salesUI.UIPaginator.previousPage.label')))), React.createElement("span", {
        className: "private-paginator__numbers"
      }, this.renderNumberedPages(maxVisiblePageButtons, page, pageCount, enabledPageLimit, disabledPageTooltipTitle)), React.createElement("span", {
        className: "private-paginator__forward-controls"
      }, React.createElement(UIButton, {
        "aria-label": I18n.text('salesUI.UIPaginator.nextPage.description'),
        className: "private-paginator__button",
        "data-next-page": true,
        disabled: page >= pageCount || enabledPageLimit != null && page >= enabledPageLimit,
        key: "next",
        onClick: partial(this.goToPage, Math.min(page + 1, pageCount)),
        responsive: false,
        size: "xs",
        use: "transparent"
      }, React.createElement("span", {
        className: arrowButtonClassName
      }, I18n.text('salesUI.UIPaginator.nextPage.label')), React.createElement(UIIcon, {
        className: "private-paginator__icon",
        name: "right",
        size: "xs"
      })), showFirstLastButtons ? React.createElement(UIButton, {
        "aria-label": I18n.text('salesUI.UIPaginator.lastPage.description'),
        className: "private-paginator__button",
        "data-last-page": true,
        disabled: enabledPageLimit != null ? page >= enabledPageLimit : pageCount === page,
        key: "last",
        onClick: partial(this.goToPage, enabledPageLimit != null ? enabledPageLimit : pageCount),
        responsive: false,
        size: "xs",
        use: "transparent"
      }, React.createElement("span", {
        className: arrowButtonClassName
      }, I18n.text('salesUI.UIPaginator.lastPage.label')), React.createElement(UIIcon, {
        className: "private-paginator__icon",
        name: "last"
      })) : null));
    }
  }]);

  return UIPaginator;
}(PureComponent);

UIPaginator.propTypes = {
  className: PropTypes.string,
  disabledPageTooltipTitle: PropTypes.node,
  maxVisiblePageButtons: PropTypes.number,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  pageCount: PropTypes.number.isRequired,
  enabledPageLimit: PropTypes.number,
  showFirstLastButtons: PropTypes.bool.isRequired,
  showButtonLabels: PropTypes.bool.isRequired
};
UIPaginator.defaultProps = {
  maxVisiblePageButtons: 11,
  showFirstLastButtons: false,
  showButtonLabels: true,
  page: 1
};
UIPaginator.displayName = 'UIPaginator';
export default Controllable(UIPaginator, ['page']);